import {
  GET_PRESIGNED_URL_REQUEST,
  GET_PRESIGNED_URL_SUCCESS,
  GET_PRESIGNED_URL_FAIL,
  UPLOAD_FILE_REQUEST,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAIL,
  DELETE_FILE_REQUEST,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  RESET_S3_UPLOAD_STATE,
} from "../../Constants/S3UploadConstants";

const initialStateDefault = {
  status: false,
  data: null,
  loading: false,
  error: null,
};

export const GetPresignedUrlReducer = (
  state = initialStateDefault,
  action: any
) => {
  switch (action.type) {
    case GET_PRESIGNED_URL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PRESIGNED_URL_SUCCESS:
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };

    case GET_PRESIGNED_URL_FAIL:
      return {
        ...state,
        status: false,
        loading: false,
        data: null,
        error: action.error,
      };

    case RESET_S3_UPLOAD_STATE:
      return initialStateDefault;

    default:
      return state;
  }
};

export const UploadFileReducer = (state = initialStateDefault, action: any) => {
  switch (action.type) {
    case UPLOAD_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };

    case UPLOAD_FILE_FAIL:
      return {
        ...state,
        status: false,
        loading: false,
        data: null,
        error: action.error,
      };

    case RESET_S3_UPLOAD_STATE:
      return initialStateDefault;

    default:
      return state;
  }
};

export const DeleteFileReducer = (state = initialStateDefault, action: any) => {
  switch (action.type) {
    case DELETE_FILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_FILE_SUCCESS:
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
        error: null,
      };

    case DELETE_FILE_FAIL:
      return {
        ...state,
        status: false,
        loading: false,
        data: null,
        error: action.error,
      };

    case RESET_S3_UPLOAD_STATE:
      return initialStateDefault;

    default:
      return state;
  }
};
